module.exports = __webpack_public_path__ + "static/media/img_guessing_bg_xz.5155fd2c.png";